<dynamic-form
  *ngIf="formGroup"
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [columns]="columns"
  reportName="MonthlyWorkInformation"
  (valueChangeByApiName)="onValueChangeByApiName($event)"
  pathPreFix="HRM"
  (cancelChange)="cancel()"
  [noSubmit]="true">
  <div class="fcContent" style="margin-top: 18px">
    <ssg-checkbox-list
      *ngIf="formGroup"
      name="ElementGroupCodes"
      textFieldName="Title"
      userClass1="row"
      userClass2="col-2"
      [dataList]="activeElement"
      systemName="HRM"
      category="ElementGroup"
      valueFieldName="Code"
      [required]="false"
      [disabled]="false"
      (valueChange)="change($event)"
      [group]="formGroup">
    </ssg-checkbox-list>
  </div>
  <ng-container class="content">
    <editable-grid
      *ngIf="MonthlyWorkInformations && MonthlyWorkInformations.length > 0"
      [isAdd]="false"
      [isDelete]="false"
      [isEdit]="true"
      rowEditableKeyNotAllow="HasCalculate"
      [columns]="dColumns"
      [height]="60"
      (afterSaved)="onValueChanges($event)"
      [(dataList)]="MonthlyWorkInformations">
    </editable-grid>
  </ng-container>
</dynamic-form>
